<template>
  <div :class="required ? 'van-cell van-cell--required hasinput' : 'van-cell van hasinput'" style="display: flex; align-items: center">
    <span>{{ name }}</span>
    <div class="van-field__body">
      <input
        v-model="inputValue"
        :type="type"
        :maxlength="max"
        :placeholder="placeholder"
        style="text-align: right"
        class="van-field__control"
        :disabled="disabled"
        @blur="inputBlur($event)"
        @input="inputChange($event)"
        :style="`color: ${color}`"
      >
    </div>
    <div v-if="errMsg" class="errMsg">
      <van-icon name="warning" />
      {{ errMsg }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonInput',
  props: {
    disabled: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    color: {
      type: String,
      default: () => {
        return ''
      }
    },
    name: {
      type: String,
      default: () => {
        return ''
      }
    },
    placeholder: {
      type: String,
      default: () => {
        return ''
      }
    },
    type: {
      type: String,
      default: () => {
        return 'text'
      }
    },
    max: {
      type: Number,
      default: () => {
        return 20
      }
    },
    value: {
      type: String,
      default: () => {
        return ''
      }
    },
    errMsg: {
      type: String,
      default: () => {
        return ''
      }
    },
    required: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    inputValue: {
      get: function() {
        return this.value
      },
      set: function(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
  },
  methods: {
    inputBlur: function($event) {
      this.$emit('inputBlured', $event)
    },
    inputChange: function($event) {
      this.$emit('inputChanged', $event)
    }
  }
}
</script>
<style lang="less">
.van-cell__title,
.van-cell__value {
  flex: none;
  width: auto;
}

.van-radio {
  margin-left: 0.25rem;
}

.van-radio-group {
  display: flex;
}

.errMsg {
  width: 100%;
  color: #e64340;
  font-size: 0.14rem;

  .svg-icon {
    margin-right: 0.05rem;
  }
}

.van-cell--required::before {
  //top: 0.16rem;
}
</style>
